import React from 'react';
import { Reveal } from './ui/Reveal';
import { BONUS_VALUE, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="border-y-2 border-volt/25 bg-carbon" data-id="element-26" data-mp="gx6poafu4kc1">
      <div className="mx-auto max-w-page px-3 py-8 sm:px-6 sm:py-10" data-id="element-27" data-mp="vu7hedy10fai">
        <Reveal className="text-center" data-id="element-28" data-mp="qsrro8kwlkls">
          <h2 id="bonos" className="font-display text-xl uppercase leading-tight text-volt sm:text-3xl lg:text-4xl" data-id="element-29" data-mp="qvw39r0p7imh">
            5 Bonos incluidos
          </h2>
          <p className="mt-1 text-[0.85rem] font-bold text-white sm:text-base" data-id="element-30" data-mp="zsewl4cud8jl">
            Y además recibes 5 recursos prácticos — GRATIS con tu compra.
          </p>
        </Reveal>

        <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-31" data-mp="19l2rftk9h2fo">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-volt/40 bg-night p-4" data-id="element-32" data-mp="1nhzjfyc48py5" data-mpi={i}>
              <span className="self-start rounded bg-volt/15 px-2 py-0.5 text-[0.68rem] font-extrabold uppercase tracking-wide text-volt sm:text-xs" data-id="element-33" data-mp="3psoe7xpkrnie">
                {bono.label}
              </span>
              <h3 className="mt-2 font-display text-[0.92rem] uppercase leading-tight text-white sm:text-[0.98rem]" data-id="element-34" data-mp="7kpaemfxsish">
                {bono.title}
              </h3>
              <p className="mt-1.5 text-[0.8rem] leading-snug text-steel sm:text-sm" data-id="element-35" data-mp="cja9gijgcwfc">
                {bono.desc}
              </p>
              <p className="mt-auto pt-3 text-[0.78rem] font-bold text-steel line-through sm:text-sm" data-id="element-36" data-mp="gj110ogszgkx">
                Valor: {bono.value}
              </p>
            </Reveal>)}

          <Reveal as="li" delay={0.16} className="flex h-full flex-col items-center justify-center rounded-xl border-2 border-volt bg-volt/10 p-4 text-center" data-id="element-37" data-mp="qd1af2j4b7zg">
            <p className="font-display text-[0.85rem] uppercase leading-tight text-white sm:text-base" data-id="element-38" data-mp="1070cy2n3strx">
              💰 Valor total de los 5 bonos:
            </p>
            <p className="mt-1 font-display text-3xl text-white line-through decoration-danger decoration-2 sm:text-4xl" data-id="element-39" data-mp="5npbw7fh60ql">
              {BONUS_VALUE}
            </p>
            <p className="mt-2 font-display text-base uppercase leading-tight text-volt sm:text-xl" data-id="element-40" data-mp="fk21at3zlsfj">
              🔥 Hoy los 5 están incluidos gratis.
            </p>
          </Reveal>
        </ul>
      </div>
    </section>;
}